import AppDispatcher from "../Dispatcher";
import AppSDK from "@growthos/ui-app-sdk";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import { fetchWithAuthGet, fetchWithAuthPost } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";

const basePath = AppConfig.getBookApiBasePath();

export const fetchPlacements = (config, campaignUniqueID, options = {}) => {
	const { abortController } = options || {};
	const fetchOptions = abortController ? { abortController } : {};
	const contextValues = BookFiltersStore.getContextValues();
	return Promise.all([
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`,
			fetchOptions
		),
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`,
			fetchOptions
		)
	]).then((response) => {
		if (abortController?.signal?.aborted) {
			return { aborted: true };
		}

		// do something with both responses
		const config = response[0];
		const data = response[1];
		const placementData = {
			config,
			data
		};
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchPlacements, // "FETCHPLACEMENTS"
			value: placementData
		});

		return { aborted: false };
	});
};

export const fetchOnlyPlacements = (config, campaignUniqueID, placementHeaders, placementsSentToPrisma, auditLevelID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${auditLevelID}/${campaignUniqueID}`
	).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchOnlyPlacements,
			value: response,
			config: placementHeaders,
			placementsSentToPrisma
		});
	});
};

export const createPlacements = (placementData, config, campaignUniqueID, onSuccessCallback) => {
	const user = AppSDK.ApiUser.getUser();
	placementData.FirstName = user?.givenName;
	placementData.LastName = user?.familyName;
	placementData.Email = user?.userName;

	const postData = JSON.stringify(placementData);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/PlacementSaveViewModel/InsertUpdatePlacements`, postData)
		.then((response) => {
			const newPlacements = Object.values(response).map((placement) => {
				return placement.Object;
			});
			newPlacements.forEach((placement) => {
				if (placement.MasterPlatformID == 5) {
					placement.ExternalSystemStatusID = 1;
					placement.TraffickingPlacementStatusID = null;
					placement.ExternalSystemResponse = "Not Synced";
				}
			});
			onSuccessCallback?.(newPlacements);
			AppDispatcher.dispatch({
				type: AppActionConstants.placementCreated,
				value: placementData
			});
		})
		.catch(async (error) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.placementFailed,
				value: placementData
			});
		});
};

export const fetchPlacementConfig = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
	).then((config) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchPlacementConfig,
			value: config
		});
	});
};

export const updatePlacementsWithPackages = (config, campaignUniqueID, packageID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return Promise.all([
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
		),
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
		)
	]).then((response) => {
		const config = response[0];
		const data = response[1];
		// do something with both responses
		const placementData = {
			config,
			data
		};
		AppDispatcher.dispatch({
			type: AppActionConstants.packageUpdated,
			value: placementData,
			packageID
		});
	});
};

export const putSheetData = (data) => {
	// We would do a put on a success update the data
	/* API ENDPOINT http://172.18.30.210/Book2API/custom/SavePlacement */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/PlacementSaveViewModel/InsertUpdatePlacement`, postData)
		.then((resp) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.putPlacementDataSuccess,
				value: resp
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.addPlacementDataFail,
				value: errorObject
			});
		});
};

export const updateSheetDataArray = (data) => {
	// We would do a put on a success update the data
	/* API ENDPOINT http://172.18.30.210/Book2API/custom/SavePlacement */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/PlacementSaveViewModel/InsertUpdatePlacements`, postData)
		.then((resp) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.putPlacementDataSuccess,
				value: resp
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.putPlacementDataFail,
				value: errorObject
			});
		});
};

export const updateSheetData = (data) => {
	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/PlacementSaveViewModel/InsertUpdatePlacements`, postData);
};

export const deleteSheetData = (data, placementIDsToDelete) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/PlacementSaveViewModel/DeletePlacement`, JSON.stringify(data))
		.then((resp) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.deletePlacementSuccess, // "DELETEPLACEMENTSUCCESS"
				value: resp,
				deleted: data,
				idsToDelete: placementIDsToDelete
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.deletePlacementFail, // "DELETEPLACEMENTFAIL"
				value: errorObject
			});
		});
};

export const syncSheetData = (config) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthPost(
		`${basePath.ApiBasePath}/plook/Placement/SyncPlacementsGoogleCampaignManager/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platformID}/${config.campaignID}`,
		JSON.stringify({})
	)
		.then((resp) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.placementSyncSuccess,
				value: resp
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.placementSyncFail,
				value: errorObject
			});
		});
};

export const addNewPackage = (pack) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.addPackage,
		value: pack
	});
};

export const setFilteredPackage = (packageDetails, clonedPlacements = [], emitAfter = true) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.setFilterPackage,
		value: packageDetails,
		clonedPlacements,
		emitAfter
	});
};

export const refetchPlacements = (config, campaignUniqueID, options = {}) => {
	const { abortController } = options || {};
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`,
		abortController ? { abortController } : {}
	)
		.then((resp) => {
			if (abortController?.signal?.aborted) {
				return { aborted: true };
			}

			AppDispatcher.dispatch({
				type: AppActionConstants.refetchPlacementsSuccess,
				value: resp
			});

			return { aborted: false };
		})
		.catch(async (error) => {
			if (abortController?.signal?.aborted || error?.name === "AbortError") {
				return { aborted: true };
			}

			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.refetchPlacementsFail,
				value: errorObject
			});

			return { aborted: false, error };
		});
};

export const pushPlacementsToPrisma = (placementIDs) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Placement/AddPlacementsToPrisma`, JSON.stringify({ PlacementIDS: placementIDs }));
};

export const updatePlacementPrismaSyncStatus = (placementIDs) => {
	AppDispatcher.dispatch({
		type: AppActionConstants.updatePlacementPrismaStatus,
		value: placementIDs
	});
};

export const triggerPlacementModal = () => {
	AppDispatcher.dispatch({
		type: AppActionConstants.triggerPlacementModal
	});
};

export const checkIfCampaignJIRATicket = (campaignID) => {
	return fetchWithAuthGet(`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/IsCampaignJIRATicketCreated/${campaignID}`);
};

export const checkTraffickingRequestValidDates = (placementIDs) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/Placement/GetTraffickingRequestValidDates`, JSON.stringify({ PlacementIDS: placementIDs }));
};

export const pushPlacementsToGCM = (placementIDs) => {
	return fetchWithAuthPost(`${basePath.ApiBasePath}/GoogleProxy/SendPlacementToGcm`, JSON.stringify(placementIDs)).finally(() => {
		AppDispatcher.dispatch({
			type: AppActionConstants.sendPlacementsToGCM
		});
	});
};
